import { IComponentOptions } from "angular";
import { MachinePartsComponentController } from "./controller";

export const vsComponentName = "machineDetailPartsComponent";

export const machinePartsComponentOptions: IComponentOptions = {
  controller: MachinePartsComponentController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    machine: "<",
    machineParts: "<",
  },
};
